import { useStoreInfo } from '../../store/useStoreInfo';
import * as S from './styles';

import hungerStationLogo from '../../assets/img/HungerStation.svg';
import keetaLogo from '../../assets/img/Keeta.svg';
import theChefzLogo from '../../assets/img/TheChefz.svg';
import jahezLogo from '../../assets/img/jahez.svg';

const APPS = [
  { key: 'chefz',         logo: theChefzLogo,     alt: 'ذا شيفز',   urlKey: 'deliveryChefzUrl'         },
  { key: 'jahez',         logo: jahezLogo,         alt: 'جاهز',       urlKey: 'deliveryJahezUrl'         },
  { key: 'hungerstation', logo: hungerStationLogo, alt: 'هنقرستيشن', urlKey: 'deliveryHungerStationUrl' },
  { key: 'keeta',         logo: keetaLogo,         alt: 'كيتا',       urlKey: 'deliveryKeetaUrl'         },
] as const;

const DeliveryAppsSkeleton = () => (
  <S.Section>
    <S.Header>
      <S.SkeletonTitle style={{ marginBottom: '8px' }} />
      <S.SkeletonBase style={{ width: '220px', height: '11px', borderRadius: '4px' }} />
    </S.Header>
    <S.Grid $count={4}>
      {Array.from({ length: 4 }).map((_, i) => (
        <S.SkeletonCard key={i}>
          <S.SkeletonLogo />
          <S.SkeletonName />
        </S.SkeletonCard>
      ))}
    </S.Grid>
  </S.Section>
);

export const DeliveryApps = () => {
  const { data, isLoading } = useStoreInfo();

  if (isLoading) return <DeliveryAppsSkeleton />;

  const visibleApps = APPS.filter(app => {
    const url = data?.[app.urlKey];
    return url && url.trim().length > 0;
  });

  if (visibleApps.length === 0) return null;

  return (
    <S.Section>
      <S.Header>
        <S.Title>اطلب عبر التطبيقات</S.Title>
        <S.Subtitle>يمكنك إيجادنا على هذه المنصات</S.Subtitle>
      </S.Header>
      <S.Grid $count={visibleApps.length}>
        {visibleApps.map(app => (
          <S.AppCard
            key={app.key}
            href={data![app.urlKey]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`اطلب عبر ${app.alt}`}
          >
            <S.AppLogoBox>
              <S.AppLogo src={app.logo} alt={app.alt} $appKey={app.key} />
            </S.AppLogoBox>
            <S.AppName>{app.alt}</S.AppName>
          </S.AppCard>
        ))}
      </S.Grid>
    </S.Section>
  );
};

export default DeliveryApps;
